export const comments_5618853 = {"data":{"data":[],"links":{}}}